import {
  RFM_OBTER_CONFIG,
  RFM_SALVAR_CONFIG,
  RFM_SIMULAR,
  RFM_LISTAR_SEGMENTOS
} from "../actions/rfm";
import { ERRORS_SHOW } from "../actions/errors";
import Api from "../../service/api-web";
import * as _ from "lodash";

const actions = {
  /**
   * 404 significa "fornecedor ainda não tem matriz configurada": resolve com
   * null para a tela assumir os valores padrão, sem exibir erro.
   */
  [RFM_OBTER_CONFIG]: ({ dispatch, getters }) => {
    return new Promise((resolve, reject) => {
      Api.v4.rfm
        .obterConfig(getters.getFornecedorId)
        .then(resp => {
          resolve(_.get(resp, "data.data", null));
        })
        .catch(err => {
          if (_.get(err, "response.status") === 404) {
            resolve(null);
            return;
          }
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },

  [RFM_SALVAR_CONFIG]: ({ dispatch, getters }, config) => {
    return new Promise((resolve, reject) => {
      Api.v4.rfm
        .salvarConfig(getters.getFornecedorId, config)
        .then(resp => {
          resolve(_.get(resp, "data.data", null));
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },

  /**
   * O simulador é a única fonte de nota, score composto e segmento. O `config`
   * enviado é sempre o rascunho da tela, para permitir simular faixas ainda
   * não salvas.
   */
  [RFM_SIMULAR]: ({ getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.rfm
        .simular(getters.getFornecedorId, payload)
        .then(resp => {
          resolve(_.get(resp, "data.data", null));
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  [RFM_LISTAR_SEGMENTOS]: () => {
    return new Promise((resolve, reject) => {
      Api.v4.rfm
        .listarSegmentos()
        .then(resp => {
          resolve(_.get(resp, "data.data", []));
        })
        .catch(err => {
          reject(err);
        });
    });
  }
};

export default {
  actions
};
